import React, { memo, useCallback } from "react";
import styles from "./styles.module.scss";
import PagePanel from "app/components/PagePanel";
import { cls } from "app/utils";
import DropdownButton from "app/components/DropdownButton";
import TabButton from "app/components/Button/TabButton";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "typedefs";
import TeamsSettings from "./TeamSettings";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface IProps {
  canViewMembers: boolean;
}

const TeamsTabsContainer = ({ canViewMembers }: IProps) => {
  const { t } = useTranslation();
  const param = useParams<{ id: string; teamId: string }>();
  const location = useLocation();
  const { selectedGroup } = useSelector(
    (state: RootState) => state.groups,
    shallowEqual,
  );
  const { selectedTeam } = useSelector(
    (state: RootState) => state.teamGroup,
    shallowEqual,
  );

  const history = useHistory();

  const route = (path: string) => {
    history.push(path);
  };

  const onTimelineClick = useCallback(() => {
    if (location.pathname.includes("members")) {
      route(`/groups/${param?.id}/channels/${param?.teamId}`);
    }
  }, [location.pathname, param?.id, param?.teamId, history]);

  const onMembersClick = useCallback(() => {
    if (!location.pathname.includes("members")) {
      route(`/groups/${param?.id}/channels/${param?.teamId}/members`);
    }
  }, [location.pathname, param?.id, param?.teamId, history]);
  if (!selectedGroup || !selectedTeam) {
    return null;
  }

  const userIcon = () => {
    return (
      <i
        className={cls("tab-icon ico", {
          ["ico-user"]: location.pathname.includes("members"),
          ["ico-user-o"]: !location.pathname.includes("members"),
        })}
      />
    );
  };

  const dropdownContent = () => {
    return (
      <DropdownButton
        btnClassName={styles.dropdown_btn_className}
        btnContent={
          <i className="dropdown-toggle btn btn-outline-secondary ico ico-cog dark" />
        }
        hideButtonStyles
      >
        <TeamsSettings />
      </DropdownButton>
    );
  };

  return (
    <div className={styles.container}>
      <PagePanel
        panelClassName={styles.panel}
        title={selectedTeam.name}
        titleStyles={cls("text-muted", styles.page_panel_title)}
        subTitle={selectedTeam.description ? selectedTeam.description : null}
        headerChildren={dropdownContent()}
      >
        <div className={styles.navbar_wrapper}>
          <TabButton
            label={t("Timeline")}
            icon={<i className={cls("tab-icon ico ico-feed-o")} />}
            isActive={!location.pathname.includes("members")}
            onClick={onTimelineClick}
            className={styles.mobile}
          />
          {canViewMembers && (
            <TabButton
              label={t("Channel Members")}
              icon={userIcon()}
              isActive={location.pathname.includes("members")}
              onClick={onMembersClick}
              className={styles.mobile}
            />
          )}{" "}
        </div>
      </PagePanel>
    </div>
  );
};

export default memo(TeamsTabsContainer);
